export const compareTwoValues = (selectedVal, currentVal) => {
  return selectedVal === currentVal;
};
